import { attr, Model, fk, ModelType } from 'redux-orm';
import {
  GET_COMPANY_SCORE_HISTORY_SUCCESS,
  GET_CONTACT_SCORE_HISTORY_SUCCESS,
  GET_COMPANY_INTERACTION_SUMMARY_SUCCESS,
  GET_COMPANY_PLANNED_INTERACTION_SUMMARY_SUCCESS,
} from 'actions';

class Score extends Model {
  static reducer(action: any, model: ModelType<Score>) {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case GET_COMPANY_SCORE_HISTORY_SUCCESS:
      case GET_CONTACT_SCORE_HISTORY_SUCCESS:
        // We clear all values
        model.all().delete();
        action.data.map((d: any) => {
          // Rather than the score id we use a combination of timestamp + companyId + contactId.  This means on subsequent requests the upsert can work
          // without creating duplicate same day events
          return model.upsert({
            ...d,
            id: `${d.companyId}-${d.contactId}-${d.timestamp}`,
          });
        });
        break;

      case GET_COMPANY_INTERACTION_SUMMARY_SUCCESS:
      case GET_COMPANY_PLANNED_INTERACTION_SUMMARY_SUCCESS:
        // We clear all values
        model.all().delete();
        action.data.forEach((d: any) => {
          const {
            startOfDay: timestamp,
            relationship,
            roleTypeInteractionSummary,
          } = d;

          model.upsert({
            id: `${action.id}-${timestamp}`,
            companyId: action.id,
            relationship,
            roleTypeInteractionSummary,
            timestamp,
            ...(action.meta || {}),
          });
        });
        break;
    }

    return undefined;
  }

  toViewModel() {
    return {
      ...this.ref,
    };
  }
}

Score.modelName = 'Score';

Score.fields = {
  id: attr(),
  accountId: attr(),
  companyId: fk('Company'),
  contactId: fk('Contact'),
  relationship: attr(),
  roleTypeInteractionSummary: attr(),
  timestamp: attr(),
};

export type ScoreViewModel = ReturnType<Score['toViewModel']>;

export default Score;
